export const PROJECT_TASK_TYPE = {
  DstSrtUploading: 'dstSrtUploading',
  SrcAndDstSrtUploading: 'srcAndDstSrtUploading',
  SrcSrtUploading: 'srcSrtUploading',
  VideoGenerating: 'videoGenerating',
  VideoUploading: 'videoUploading',
  VideoUploadingWithGenerating: 'videoUploadingWithGenerating',
  VideoWithDstSrtUploading: 'videoWithDstSrtUploading',
  VideoWithDstSrtUploadingWithGenerating: 'videoWithDstSrtUploadingWithGenerating',
  VideoWithSrcSrtUploading: 'videoWithSrcSrtUploading',
  VideoWithSrcSrtUploadingWithGenerating: 'videoWithSrcSrtUploadingWithGenerating',
  VoiceUpdate: 'voiceUpdate',
} as const;
